const STORAGE_KEY = 'cart_checkbox_state';

/**
 * Читает сохранённое состояние чекбоксов из localStorage.
 * @returns {Object} — объект вида { articleId: true/false }
 */
const getCheckboxState = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (e) {
        return {};
    }
};

/**
 * Сохраняет полный объект состояний в localStorage.
 * @param {Object} state — объект вида { articleId: true/false }
 */
const saveCheckboxState = (state) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
};

/**
 * Обновляет состояние одного товара и сохраняет.
 * @param {string|number} article — артикул товара
 * @param {boolean} checked — выбран или нет
 */
const setArticleChecked = (article, checked) => {
    const state = getCheckboxState();
    state[String(article)] = checked;
    saveCheckboxState(state);
};

/**
 * Сохраняет состояние всех товаров одновременно.
 * @param {Object} articlesObj — объект вида { articleId: true/false }
 */
const saveAllArticlesState = (articlesObj) => {
    const state = getCheckboxState();
    Object.keys(articlesObj).forEach(article => {
        state[String(article)] = articlesObj[article];
    });
    saveCheckboxState(state);
};

/**
 * Очищает сохранённое состояние чекбоксов.
 */
const clearCheckboxState = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
};

export {
    getCheckboxState,
    saveCheckboxState,
    setArticleChecked,
    saveAllArticlesState,
    clearCheckboxState,
};
